import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Helmet } from "react-helmet";
import parentTheme from "./theme";

interface Props {
  children: React.ReactNode;
}

export const ThemeContext = React.createContext("PARENT");

const Layout: React.FC<Props> = ({ children }: Props) => {
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <link
          href="https://fonts.googleapis.com/css?family=DM+Sans:400,500,700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Andika+New+Basic:400,500,700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <ThemeProvider theme={parentTheme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <ThemeContext.Provider value={"PARENT"}>
          <CssBaseline />
          {children}
        </ThemeContext.Provider>
      </ThemeProvider>
    </>
  );
};

export default Layout;
